var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-3",attrs:{"fluid":""}},[_c('div',{staticClass:"d-flex flex-row flex-wrap justify-content-between"},[_c('h3',{staticClass:"mt-2 font-italic"},[_vm._v(" "+_vm._s(_vm.park.name)+" - "+_vm._s(_vm.park.account.description)+" ")])]),_c('park',{attrs:{"parkId":_vm.$route.params.park}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }